import { useState } from 'react'
import { Toast } from 'react-bootstrap'
import './EqxGlobalMessages.css'
const useGlobalMessages = () => {
    const [messages, setMessages] = useState<Message[]>([])
    const addMessage = (
        text: string,
        type?: 'error' | 'info' | 'warning' | 'success' | 'loading',
        index?: string,
        autohide?: boolean
    ) => {
        if (!index) index = Math.random().toString(36).substring(7)
        if (!type) type = 'info'
        autohide = autohide ?? type != 'loading'
        const message: Message = {
            message: text,
            index,
            type,
            autohide,
        }
        const newMessages = messages.filter((message) => message.index !== index)
        setMessages([...newMessages, message])
    }
    const removeMessage = (index: string) => {
        setMessages(messages.filter((message) => message.index !== index))
    }
    const addSuccessMessage = (text: string, index?: string, autohide?: boolean) => {
        addMessage(text, 'success', index, autohide)
    }
    const addErrorMessage = (text: string, index?: string, autohide?: boolean) => {
        addMessage(text, 'error', index, autohide)
    }
    const addInfoMessage = (text: string, index?: string, autohide?: boolean) => {
        addMessage(text, 'info', index, autohide)
    }
    const addWarningMessage = (text: string, index?: string, autohide?: boolean) => {
        addMessage(text, 'warning', index, autohide)
    }
    const addLoadingMessage = (text: string, index?: string, autohide?: boolean) => {
        addMessage(text, 'loading', index, autohide)
    }
    return {
        messages,
        addMessage,
        removeMessage,
        addSuccessMessage,
        addErrorMessage,
        addInfoMessage,
        addWarningMessage,
        addLoadingMessage,
    }
}
interface Message {
    message: string
    type?: 'error' | 'info' | 'warning' | 'success' | 'loading'
    index: string
    autohide?: boolean
}
const GlobalMessageContainer = (props: { messages: Message[]; removeMessage: (index: string) => void }) => {
    const messages = props.messages
    const removeMessage = props.removeMessage
    //handle close
    const closeHandler = (index: string) => {
        removeMessage(index)
    }
    //output messages as bootstrap toasts
    return (
        <div className="eqx-messages">
            {messages.map((message) => {
                const type = message.type === 'loading' ? 'info' : message.type == 'error' ? 'danger' : message.type
                return (
                    <Toast
                        onClose={() => closeHandler(message.index)}
                        key={message.index}
                        bg={type}
                        className="eqx-message"
                        autohide={message.autohide ? true : undefined}
                        delay={5000}
                    >
                        <Toast.Body>
                            <span className="eqx-message-icon">
                                {message.type == 'success' ? <i className="fas fa-check-circle"></i> : ''}
                                {message.type == 'error' ? <i className="fas fa-exclamation-circle"></i> : ''}
                                {message.type == 'info' ? <i className="fas fa-info-circle"></i> : ''}
                                {message.type == 'warning' ? <i className="fas fa-exclamation-triangle"></i> : ''}
                                {message.type == 'loading' ? <i className="fas fa-spinner fa-spin"></i> : ''}
                            </span>
                            {message.message}
                            <button
                                type="button"
                                className="btn-close eqx-message-close-btn"
                                onClick={() => closeHandler(message.index)}
                            ></button>
                        </Toast.Body>
                    </Toast>
                )
            })}
        </div>
    )
}
export { GlobalMessageContainer as default, useGlobalMessages }

